import { Ajax } from "../../../Common/Ajax";
import { GlobalData } from "../../../Common/GlobalData";
import { Notification } from "../../../Common/KendoHelpers";

export class TheNewAmericaModel {
    public symbol: string | null = null;
    public updateDate: string | null = null;
}

export class Create {
    private static readonly SYMBOL = '#Symbol';
    private static readonly UPDATE_DATE = '#UpdateDate';
    private static readonly SUBMIT = '#Submit';

    constructor() {
        this.init();
    }

    private init() {
        $(Create.UPDATE_DATE).kendoDatePicker({
            dateInput: true,
        });

        $(Create.SUBMIT).on('click', () => {
            this.save();
        });
    }

    public save() {
        const model = new TheNewAmericaModel();
        model.symbol = $(Create.SYMBOL).val()?.toString() || null;
        model.updateDate = $(Create.UPDATE_DATE).val()?.toString() || null;

        const msg = new Notification();

        const success = (data: TheNewAmericaModel) => {
            msg.success('The record for ' + model.symbol + ' was updated successfully');
        };

        const error = () => {
            msg.error('The record for ' + model.symbol + ' could not be updated');
        }

        Ajax.invoke(GlobalData.URL_SUFFIX_IBD_WEBSITE_THE_NEW_AMERICA,
            'POST', model, success, error);
    }
}
